import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "kepler";
import { parseMessages } from '../../../utilityHelper';

const propertyInfo = parseMessages('ppcc/confirmation/confirmation-home');
const templateData = $('body').data();

export default class NotNowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			modalIsOpen: this.props.isOpen || false
        };
		this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
		this.setState({
			modalIsOpen: nextProps.isOpen
		});
   }

	closeModal(){
		this.setState({
			modalIsOpen: false
		});
	}

    render() {
		const ratesResult = templateData.ratesResult;
		let labels = propertyInfo.notNow;
		let ppccTxnRate = `${ratesResult.ppccTxnRate_percent} + ${ratesResult.ppccCharityRate}`,
			notNowP1 = (labels && labels.p1) ? labels.p1.replace('{ppccTxnRate}', ppccTxnRate) : '';
	        return (
				<Modal
					isOpen={this.state.modalIsOpen}
					onCancel={this.closeModal}
					backdropClosesModal={true}
					type="default"
				>
					<ModalBody>
						<h3>{labels.title}</h3>
						<p className="vx_text-body-md">{notNowP1}</p>
						<p className="vx_text-body-md">{labels.p3}</p>
						<Button type="primary" id="modelClose" onClick={this.closeModal}>{labels.continueBtn}</Button>
						<p className="vx_text-3">
							{this.props.viewNotStarted ? <a onClick={this.props.viewNotStarted}>{labels.leaveNow}</a> : <a href="dashboard">{labels.leaveNow}</a> }
						</p>
					</ModalBody>
					<ModalFooter/>
				</Modal>
	        )
    }
};



// WEBPACK FOOTER //
// ./ppcc/confirmation/components/notNowModal.js